import documentScanStart from "./documentScanStart";
import manualDocumentCapture from "./manualDocumentCapture";
import myDocuments from "./myDocuments";
import paperworkLoadingMessages from "./paperworkLoadingMessages";
import reactSchemaForm from "./reactSchemaForm";

export default [
    documentScanStart,
    manualDocumentCapture,
    myDocuments,
    paperworkLoadingMessages,
    reactSchemaForm,
];
